import { useEffect, useState } from "react";
import { Lightbulb, ChevronLeft, ChevronRight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const PILLS = [
  { t: "clima", x: "nelle cliniche la temperatura media è di 20-22 °C anche in inverno, ma gli sbalzi termici richiedono cotone caldo e ciniglia." },
  { t: "taglie", x: "le ecografie hanno un margine di errore del 10%: la taglia 0-1 mese è pensata proprio per vestire bene sia i bimbi da 2,8 kg che quelli da 3,5 kg." },
  { t: "taglie", x: "nei primi 3 mesi un neonato cresce in media 3-4 cm al mese: per questo conviene non esagerare con i capi in taglia nascita." },
  { t: "taglie", x: "la lunghezza del bimbo conta più dell'età: se una tutina tira sui piedini, è ora di passare alla taglia successiva." },
  { t: "tessuti", x: "il cotone al 100% assorbe l'umidità e lascia respirare la pelle, riducendo arrossamenti e sudore." },
  { t: "tessuti", x: "la ciniglia di cotone è morbida e calda, ma resta traspirante: perfetta per l'autunno e l'inverno." },
  { t: "tessuti", x: "la mussola è formata da strati sottili di cotone: più la lavi, più diventa morbida." },
  { t: "clima", x: "per vestire il neonato vale la regola dello strato in più: un livello in più di quello che indossi tu." },
  { t: "clima", x: "per capire se il bimbo ha caldo o freddo, tocca la nuca e non le manine, che sono spesso fresche." },
  { t: "lavaggio", x: "i capi nuovi andrebbero sempre lavati prima di indossarli, per eliminare residui di lavorazione." },
  { t: "lavaggio", x: "per la pelle del neonato bastano 30-40 °C e un detersivo delicato, senza ammorbidente." },
  { t: "lavaggio", x: "asciugare all'aria, lontano dai termosifoni, aiuta il cotone a non restringersi." },
  { t: "crescita", x: "nei primi giorni è normale che il neonato perda fino al 10% del peso: lo recupera di solito entro 2 settimane." },
  { t: "crescita", x: "le curve OMS descrivono come crescono i bimbi allattati in buona salute: il percentile conta meno della sua costanza nel tempo." },
  { t: "sonno", x: "il sacco nanna è più sicuro di una coperta: non si sposta, non copre il viso e tiene il bimbo al caldo tutta la notte." },
  { t: "sonno", x: "la temperatura ideale della cameretta è tra 18 e 20 °C: un po' fresca aiuta un sonno più tranquillo." },
  { t: "sonno", x: "una piccola routine sempre uguale, come bagnetto, pigiamino e ninna nanna, aiuta il neonato a riconoscere la notte." },
];

const LESSON_TOPICS = { taglie: ["taglie"], tessuti: ["tessuti"], stagione: ["clima"], valigia: ["clima", "taglie"], lavaggio: ["lavaggio", "tessuti"], crescita: ["crescita", "taglie"], sonno: ["sonno", "clima"] };

export const FactPills = ({ topic, className = "" }) => {
  const topics = topic && LESSON_TOPICS[topic];
  const list = topics ? PILLS.filter((p) => topics.includes(p.t)) : PILLS;
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    if (paused || list.length < 2) return undefined;
    const id = setInterval(() => setI((v) => (v + 1) % list.length), 7000);
    return () => clearInterval(id);
  }, [paused, list.length]);
  const go = (d) => setI((v) => (v + d + list.length) % list.length);

  return (
    <div data-testid="fact-pills" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}
      className={`flex items-center gap-2 sm:gap-3 rounded-2xl bg-[#FDF6E7] border border-[#F1E2BF] px-3 sm:px-5 py-3 ${className}`}>
      <Lightbulb size={20} className="shrink-0 text-[#C29638]" />
      <div className="flex-1 min-h-[60px] sm:min-h-[44px] flex items-center overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.p key={i} data-testid="fact-pill-text" initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.3 }} className="text-[13px] sm:text-sm leading-snug text-[#5C534E]">
            <strong className="text-[#A87F2A]">Lo sapevi che…</strong> {list[i % list.length].x}
          </motion.p>
        </AnimatePresence>
      </div>
      <div className="flex shrink-0">
        <button data-testid="fact-pill-prev" onClick={() => go(-1)} aria-label="Pillola precedente"
          className="w-9 h-9 inline-flex items-center justify-center rounded-full text-[#A87F2A] hover:bg-[#F7E9C8] transition-colors"><ChevronLeft size={18} /></button>
        <button data-testid="fact-pill-next" onClick={() => go(1)} aria-label="Pillola successiva"
          className="w-9 h-9 inline-flex items-center justify-center rounded-full text-[#A87F2A] hover:bg-[#F7E9C8] transition-colors"><ChevronRight size={18} /></button>
      </div>
    </div>
  );
};
